import axios from "axios";
import { config } from "config";

export const axiosInstance = axios.create({
  baseURL: config.PERSONAL_PROFILE.BASE_URL,
  timeout: 5000,
});
